<div class="page_layout">
  <ul class="arada">
    <li>A</li>
    <li>R</li>
    <li>A</li>
    <li>D</li>
    <li>A</li>
  </ul>
  <ul class="home1">
    <li>H</li>
    <li>O</li>
    <li>M</li>
    <li>E</li>
  </ul>
  <ul class="away">
    <li>A</li>
    <li>W</li>
    <li>A</li>
    <li>Y</li>
  </ul>
  <ul class="from">
    <li>F</li>
    <li>R</li>
    <li>O</li>
    <li>M</li>
  </ul>
  <ul class="home2">
    <li>H</li>
    <li>O</li>
    <li>M</li>
    <li>E</li>
  </ul>
</div>
